var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form"},[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-textarea',{attrs:{"validations":_vm.validations.observacoes,"rows":"6"},model:{value:(_vm.especialidade.observacoes),callback:function ($$v) {_vm.$set(_vm.especialidade, "observacoes", $$v)},expression:"especialidade.observacoes"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }